import '../static/dashboard.scss';
 import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../static/popup.scss';
import { Navigate } from 'react-router-dom';
import '../static/gridlistbutton.scss';
import '../static/dashboard-modern.css';
// A functional component for rendering a single button

import MonthlyCalendarBoard from "../components/MonthlyCalendarBoard";
import "../static/dashboard-ipad.css";

import AppointmentSummaryCards from "../components/AppointmentSummaryCards";


const Index= () => {

const [showModal, setShowModal] = useState(false);
const [selectedItem, setSelectedItem] = useState(null);
const [staff, setStaff] = useState('');
const [done, setDone] = useState(false);
const [allStaff, setAllStaff] = useState([]);
  const [filteredStaff, setFilteredStaff] = useState([]);
 const navigate = useNavigate(); // ✅ Call the hook directly inside the function component
    const handleClick = (c) => {
        navigate(`/index?id=${encodeURIComponent(c)}`);
    }


const [groomingDataTable, setgroomingDataTable] = useState([]);
const [visibleMonth, setVisibleMonth] = useState(() => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), 1);
});

const [groomingDataDay, setGroomingDataDay] = useState([]);
const [quickCalendarItems, setQuickCalendarItems] = useState([]);

useEffect(() => {
  const loadQuickAppointments = async () => {
    try {
      const response = await axios.get(
        "/petgrooming/quick-appointments/"
      );

      const items = Array.isArray(response.data) ? response.data : [];

      const mappedItems = items
        .filter((item) => item.status === "new")
        .map((item) => ({
          id: `${item.source || "quick"}-${item.id}`,
          quickId: item.source === "quick" ? item.id : null,
          websiteBookingId:
            item.source === "website"
              ? item.website_booking_id || item.id
              : null,
          appointmentId: item.appointment_id || null,
          source: item.source || "quick",
          datee: item.appointment_date,
          hour: item.appointment_hour,
          petname: item.pet_name,
          ownername: item.owner_name
            ? `${item.owner_name} · ${item.owner_phone}`
            : item.owner_phone,
          owner_name: item.owner_name || "",
          phone: item.owner_phone,
          catordog: item.catdog,
          behaviour:
            item.source === "website"
              ? "Website booking"
              : "Details pending",
          note: item.note || "",
        }));

      setQuickCalendarItems(mappedItems);
    } catch (error) {
      console.error("Failed to fetch quick appointments:", error);
    }
  };

  loadQuickAppointments();
}, []);

const ButtonComponent = ({ className, name, onClick }) => (
  <button className={className} onClick={() => handleClick(name)}>
    {name}
  </button>
); 
 
const chars1 = [
  { className: 'new-grooming-with-phone', name: 'Grooming Phone' },
  { className: 'new-grooming', name: 'New Grooming' },
  { className: 'grooming-with-name', name: 'Grooming Name' }, 
];
const chars2 = [ 
  { className: 'Calender', name: 'Calender' }, 
];

const chars3 = [ 
  { className: 'pet-walking-week', name: 'Pet Walking' },
  { className: 'day-care', name: 'Day Care' }, 
];
const chars4 = [ 
  { className: 'vip-client', name: 'VIP Client' },
  { className: 'teeth', name: 'Teeth' },
  { className: 'teeth-ultrasound', name: 'Teeth Ultrasound' },
];

const chars5 = [
  { className: 'week-appointment', name: 'Week Appointment' },
  { className: 'today-appointment', name: 'Today Appointment' },
  { className: 'tomorrow-appointment', name: 'Tomorrow Appointment' }, 
];
const chars6 = [ 
  { className: 'stuff', name: 'Stuff' },
  { className: 'last-notes', name: 'Last Notes' },
  { className: 'owners', name: 'owners' },
];
const [responseMessage, setResponseMessage] = useState("");

 
  
  const [groomingData, setGroomingData] = useState([]);
  
  

 
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() );
  const formattedDate = tomorrow.toISOString().split('T')[0]; // yyyy-mm-dd
  


/*
 useEffect(() => {
  axios.get(`/fetch-service/?service=grooming&date=${formattedDate}`)
    .then((res) => {
      setGroomingData(res.data);
    })
    .catch((err) => console.error("Failed to fetch grooming data:", err));
}, [formattedDate]);  // <-- include it here
*/
//const currentDate = new Date();
// Get today's date

  // Define today
  const today = new Date();

  // 100 days before today
  const hundredDaysBefore = new Date();
  hundredDaysBefore.setDate(today.getDate() - 100);
  const formattedBefore = hundredDaysBefore.toISOString().split('T')[0]; // yyyy-mm-dd

  // 100 days after today
  const hundredDaysAfter = new Date();
  hundredDaysAfter.setDate(today.getDate() + 100);
  const formattedAfter = hundredDaysAfter.toISOString().split('T')[0]; // yyyy-mm-dd

  useEffect(() => {
      axios.get(`/fetch-service/?service=grooming&date=${formattedAfter}&beforedate=${formattedBefore}`)
      .then((res) => {
        console.log("Fetched grooming data:", res.data);
        setGroomingData(res.data.grooming); // Adjust if response structure differs
      })
      .catch((err) => console.error("Failed to fetch grooming data:", err));
  }, [formattedBefore, formattedAfter]);
/*
Table Data

*/
  const [startOfWeek, setStartOfWeek] = useState(getMonday(new Date())); // Current week's Monday

 
  function changeWeekTable(offset) {
    const newDate = new Date(startOfWeek);
    newDate.setDate(newDate.getDate() + offset * 7);
    setStartOfWeek(getMonday(newDate));
  }
  useEffect(() => {
      axios.get(`/fetch-service/?service=grooming&date=${formattedAfter}&beforedate=${formattedBefore}`)
      .then((res) => {
        console.log("Fetched grooming data:", res.data);
        setgroomingDataTable(res.data.grooming); // Adjust if response structure differs
      })
      .catch((err) => console.error("Failed to fetch grooming data:", err));
  }, [formattedBefore, formattedAfter]);
    function getweekDaysTable(start) {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      days.push(d);
    }
    return days;
  }

  const weekDaysTable = getweekDaysTable(startOfWeek);
  // Fetch grooming data for the week
useEffect(() => {
  const firstDay = new Date(
    visibleMonth.getFullYear(),
    visibleMonth.getMonth(),
    1
  );

  const mondayOffset = (firstDay.getDay() + 6) % 7;

  const rangeStart = new Date(
    visibleMonth.getFullYear(),
    visibleMonth.getMonth(),
    1 - mondayOffset
  );

  const rangeEnd = new Date(rangeStart);
  rangeEnd.setDate(rangeStart.getDate() + 41);

  const toDateKey = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  axios
    .get(
      `/fetch-service/?service=grooming&date=${toDateKey(
        rangeEnd
      )}&beforedate=${toDateKey(rangeStart)}`
    )
    .then((res) => {
      setgroomingDataTable(res.data.grooming || []);
    })
    .catch((err) => {
      console.error("Failed to fetch monthly grooming data:", err);
    });
}, [visibleMonth]);

/*
Table Data

*/
  const [showPopup, setShowPopup] = useState(false);
 
  const handleSubmitnote = async (e) => {
  e.preventDefault();

  const formData = {
    note: e.target.note.value,
    id: e.target.id.value,
  };

  try {
    const response = await axios.put("/create_grooming/", formData);

    if (response.status === 200 || response.status === 201) {
      setResponseMessage("Pet walking note updated successfully.");
      alert("Pet walking note updated successfully.");
    } else {
      setResponseMessage("Failed to update note: " + JSON.stringify(response.data));
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    setResponseMessage("An error occurred. Please try again.");
    alert("An error occurred. Please try again.");
  }
};

  const [MessagePet, setMessagePet] = useState([]);


  useEffect(() => {
    axios.get(`/message-pet/?number=2`)
        .then((res) => {
          setMessagePet(res.data);
        })
        .catch((err) => console.error("Failed to fetch Message of Pet  data:", err));
    }, []);
/*
Autocomplete Search and refer to other page:

*/

  const [formData, setFormData] = useState({
         name: '',
        phone: ''
      });
  const [suggestions, setSuggestions] = useState([]);
  const [selectedPetId, setSelectedPetId] = useState(null);

    
  
  // Function to fetch pet names for autocomplete
  const fetchSuggestions = async (query) => {
    try {
    const response = await fetch(`/autocomplete-pet-names/?query=${query}`);
    const data = await response.json();
    setSuggestions(data.suggestions || []);
  } catch (error) {
    alert('Error fetching Telephone:', error);
    console.error('Error fetching Telephone:', error);
  }
  };


  // Fetch autocomplete suggestions when the name input changes
const handleNameChange = async (e) => {
  const { value } = e.target;
  setFormData((prevState) => ({
    ...prevState,
    name: value,
    phone: '',   // <-- update name here, not name
  }));

  if (value.length > 2) {
    fetchSuggestions(value);
  } else {
    setSuggestions([]);
  }
};
  
  const handleSuggestionClick = (suggestion) => {
    setFormData((prevState) => ({
      ...formData,
      name: suggestion.name,
    phone: suggestion.phone,
    }));
    setSuggestions([]); // Clear suggestions after selecting one
  };

    // Handle change in other input fields (e.g., owner's name)
    const handleChange = (e) => {
      const { name, value } = e.target;  // e.target doesn't have 'name' attribute, so this will be undefined
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,   // this won't work as expected
      }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { phone } = formData;

        try {
        const queryParams = new URLSearchParams({ phone }).toString();
      
        const response = await fetch(`/fetch-pet/?${queryParams}`);

          if (!response.ok) {
            setResponseMessage('Pet not found.');
            return;
          }

          const data = await response.json();

          // Safely build URL query string for navigation
          const query = new URLSearchParams({
            id: data.id || '',
            name: data.name || '',
            catdog: data.catdog || '',
            owner: data.owner || '',
            image: data.image || '1.png',
            phone: data.phone || '',
            breed: data.breed || '',
            age: data.age?.toString() || '',
            behaviour: data.behaviour || '',
            allergies: data.allergies || '',
            vaccinated: data.vaccinated?.toString() || '',
            grooming_history: data.grooming_history || '',
            booking_date: data.booking_date || '',
            extra_info: data.extra_info || '',
            text: data.text || ''
          }).toString();

          navigate(`/historygroom/?${query}`);
          } catch (error) {
          console.error('Error fetching pet:', error);
          setResponseMessage('An error occurred. Please try again.');
          }
          };
 /*
Autocomplete Search and refer to other page:

*/   


const [currentDate, setCurrentDate] = useState(new Date());



/*
Calender
*/


 
  const closePopup = () => setShowPopup(false);

  function getMonday(date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when Sunday
    return new Date(d.setDate(diff));
  }

  function changeWeek(offset) {
    const newDate = new Date(startOfWeek);
    newDate.setDate(newDate.getDate() + offset * 7);
    setStartOfWeek(getMonday(newDate));
  }

  function getWeekDays(start) {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(start);
      d.setDate(start.getDate() + i);
      days.push(d);
    }
    return days;
  }

  const weekDays = getWeekDays(startOfWeek);

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

  // Fetch grooming data for the week
  useEffect(() => {
    const start = formatDate(weekDays[0]);
    const end = formatDate(weekDays[6]);

    axios
      .get(`/fetch-service/?service=grooming&date=${end}&beforedate=${start}`)
      .then((res) => {
        setGroomingData(res.data.grooming || []);
      })
      .catch((err) => console.error("Failed to fetch grooming data:", err));
  }, [startOfWeek]); // refetch on week change


useEffect(() => {
  const dateStr = formatDate(currentDate); // Ensure formatDate outputs 'YYYY-MM-DD'
  //alert(dateStr);
  axios
    .get(`/fetch-service2/?service=grooming&date=${dateStr}`)
    .then((res) => {
      console.log("Backend response:", res.data);
      setGroomingDataDay(res.data.grooming || []);
    })
    .catch((err) => console.error("Failed to fetch grooming data:", err));
}, [currentDate]);


  const hours = Array.from({ length: 13 }, (_, i) => 8 + i); // 8 to 20
  
/*
Calender
*/
function changeDay(offset) {
  const newDate = new Date(currentDate);
  newDate.setDate(newDate.getDate() + offset);
  setCurrentDate(newDate);
}

 const handleOpenModal = (item) => {
  if (item.source === "quick") {
    navigate(quickProfilePath(item));
    return;
  }

  if (item.source === "website") {
    alert(
      "This booking came from arys.co.uk and is already saved in Appointment."
    );
    return;
  }

  setSelectedItem(item);
  setStaff(item.staff || "");
  setDone(item.done || false);
  setShowModal(true);
};

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

const handleUpdate = async () => {
    try {
      const response = await fetch(`/update-grooming/${selectedItem.id}/`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ staff, done }),
      });
      if (response.ok) {
        alert('Updated successfully!');
        handleCloseModal();
        window.location.reload(); // or refresh state properly
      }
    } catch (error) {
      console.error('Error updating:', error);
    }
  };
  useEffect(() => {
    // Fetch staff data on component mount
    fetch('/staff/')
      .then((res) => res.json())
      .then((data) => {
        setAllStaff(data);
      })
      .catch((error) => {
        console.error('Error fetching staff:', error);
      });
  }, []);
useEffect(() => {
  const searchValue = typeof staff === 'string' ? staff.toLowerCase() : '';

  const filtered = allStaff.filter((s) =>
    s.name.toLowerCase().includes(searchValue)
  );
  setFilteredStaff(filtered);
}, [staff, allStaff]);
    const handleAssignStaff = (staff) => {
    console.log('Selected staff:', staff);
    // You can update form state, send to backend, etc.
  };

  const getStatusLabel = (status) => {
    if (status === 'active') return '🟢 Active';
    if (status === 'inactive') return '🔴 Inactive';
    return '⚪ Unknown';
  };

//Delete Appointment
  const [showModal2, setShowModal2] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

const handleDelete = async (item = null) => {
  const target =
    item ||
    (selectedId
      ? {
          id: selectedId,
          source: "grooming",
        }
      : null);

  if (!target) return;

  if (target.source === "website") {
    alert(
      "This booking came from arys.co.uk. Do not delete it from Quick Booking."
    );
    return;
  }

  if (
    item &&
    !window.confirm(
      `Delete appointment for ${target.petname || "this pet"}?`
    )
  ) {
    return;
  }

  try {
    if (target.source === "quick") {
      await axios.delete(
        `/petgrooming/quick-appointments/${target.quickId}/`
      );
    } else {
      await axios.delete(`/grooming/${target.id}/delete/`);
    }

    alert("Appointment deleted successfully.");
    setShowModal2(false);
    window.location.reload();
  } catch (error) {
    console.error(error);
    alert("Could not delete this appointment.");
  }
};

const allGroomingEvents = [
  ...groomingData,
  ...quickCalendarItems,
];

const allTableEvents = [
  ...groomingDataTable,
  ...quickCalendarItems,
];

const currentDateEvents = [
  ...groomingDataDay,
  ...quickCalendarItems.filter(
    (item) => item.datee === formatDate(currentDate)
  ),
];

const quickProfilePath = (item) => {
  const query = new URLSearchParams({
    quick_id: item.quickId || "",
    pet_name: item.petname || "",
    owner_name: item.owner_name || "",
    phone: item.phone || "",
    catdog: item.catordog || "Dog",
  }).toString();

  return `/MakeAppointment?${query}`;
};


const changeMonth = (offset) => {
  setVisibleMonth((current) => {
    return new Date(
      current.getFullYear(),
      current.getMonth() + offset,
      1
    );
  });
};

const goToCurrentMonth = () => {
  const now = new Date();
  setVisibleMonth(new Date(now.getFullYear(), now.getMonth(), 1));
};

const addLocalDays = (date, numberOfDays) => {
  const result = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );

  result.setDate(result.getDate() + numberOfDays);
  return result;
};

const countAppointmentsForDate = (date) => {
  const key = formatDate(date);

  return allTableEvents.filter((item) => item.datee === key).length;
};

const selectedMonthPrefix = `${visibleMonth.getFullYear()}-${String(
  visibleMonth.getMonth() + 1
).padStart(2, "0")}`;

const selectedMonthCount = allTableEvents.filter((item) =>
  String(item.datee || "").startsWith(selectedMonthPrefix)
).length;

const statsToday = new Date();
const statsTomorrow = addLocalDays(statsToday, 1);
const statsDayAfterTomorrow = addLocalDays(statsToday, 2);
const summaryCards = [
  {
    kind: "month",
    title: "Booked this month",
    value: selectedMonthCount,
    subtitle: visibleMonth.toLocaleDateString("en-GB", {
      month: "long",
      year: "numeric",
    }),
  },
  {
    kind: "today",
    title: "Today",
    value: countAppointmentsForDate(statsToday),
    subtitle: formatDate(statsToday),
  },
  {
    kind: "tomorrow",
    title: "Tomorrow",
    value: countAppointmentsForDate(statsTomorrow),
    subtitle: formatDate(statsTomorrow),
  },
  {
    kind: "after-tomorrow",
    title: "Day after tomorrow",
    value: countAppointmentsForDate(statsDayAfterTomorrow),
    subtitle: formatDate(statsDayAfterTomorrow),
  },
];



  return (
    <>
      <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet' />
      

      <section id="content" className="dashboard-modern">
         

        <main className="dashboard-shell">
         {/* Left Column */}
  <div style={{
    width: '20%',
    padding: '1rem',
    overflowY: 'auto',
    backgroundColor: '#f4f4f4',
    position: 'sticky',
    top: 0,
    height: '100vh',
    flexShrink: 0
  }} >
    <div className="main-header">
      
        <form className="contact-form" onSubmit={handleSubmit}>
        <label>Phone of Pet</label>
        <div className="input-block">
            <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleNameChange}
            className="form-control"
            autoComplete="off"
            />

            <input
            name="phone"
            value={formData.phone}
            className="form-control"
            readOnly
            />

            {suggestions.length > 0 && (
            <div className="autocomplete-suggestions">
                {suggestions.map((suggestion) => (
                <div className="input-block" key={suggestion.id}>
                    <input
                    type="text"
                    className="form-control mt-1"
                    value={`${suggestion.name} (${suggestion.phone})`}
                    onClick={() => handleSuggestionClick(suggestion)}
                    readOnly
                    />
                </div>
                ))}
            </div>
            )}
        </div>

        <div className="mt-3">
            <button type="submit" className="square-button">Find Out</button>
        </div>
        </form>
    </div>
     <div className="horizontal-tabs">
      {[
        "My details", "Profile", "Password", "Team", "Plan", "Billing",
        "Email", "Notifications", "Integrations", "API"
      ].map(tab => (
        <a href="#" className={tab === "Integrations" ? "active" : ""} key={tab}>{tab}</a>
      ))}
    </div>
  </div>
{/* Middle Column */}
  <div style={{
    width: '60%',
    overflowY: 'scroll',
    height: '100vh',
    padding: '1rem'
  }}>


<div className="table-data">
  <div className="todo" style={{ width: '100%' }}>
    <div className="head">
      <h3>Grooming Calendar -  {startOfWeek.toDateString()}</h3>
      <i className="bx bx-plus icon"></i>
      <i className="bx bx-filter"></i>
    </div>

    <div className="week-navigation">
      <button className="button" onClick={() => changeDay(-1)}>Previous Day</button>
      <button className="button" style={{ backgroundColor: 'red' }} onClick={() => changeDay(1)}>Next Day</button>
    </div>

    <div className="single-day-calendar" style={{ marginTop: '20px' }}>
      <h4 style={{ textAlign: 'center', marginBottom: '10px' }}>
        {currentDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
      </h4>

      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        maxWidth: '500px',
        margin: '0 auto'
      }}>
{currentDateEvents.length > 0 ? (
        currentDateEvents.map((item, idx) => {
         let bgColor = '';
          if (item.behaviour === "Big") bgColor = 'lightyellow';
          else if (item.behaviour === "Aggressive") bgColor = 'lightcoral';
          else if (item.catordog == "Cat") bgColor = 'lightsalmon';
          else if (item.catordog == "Dog") bgColor = 'lightgreen';
          else bgColor = 'white';

          return (
            <div key={idx} style={{
              backgroundColor: bgColor,
              borderRadius: '10px',
              padding: '12px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              position: 'relative'
            }}>  
               
               
              <h5>{item.catordog}</h5>
              <p>Pet: {item.petname}</p>
              <p>Time: {item.hour}</p>
              <p>Time: {item.behaviour}</p>
              <button
                onClick={() => handleOpenModal(item)}
                style={{
                   borderRadius: '9999px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      backgroundColor: '#29c65dff', // pink
      color: '#12791eff',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
                }}
              >
                Update
              </button>
{/* Delete Appointment */}
  <button
    onClick={() => {
      setSelectedId(item.id);
      setShowModal2(true);
    }}
    style={{
      borderRadius: '9999px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      backgroundColor: '#c4decdff', // red
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
    }}
  >
    Delete
  </button>

          {/* Confirmation Modal */}
      {showModal2 && (
      <div
    style={{
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0,0,0,0.4)', // dark overlay
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    }}
  >
    <div
      style={{
        backgroundColor: '#fff',
        padding: '24px 32px',
        borderRadius: '16px', // nice round corners
        boxShadow: '0 8px 20px rgba(0,0,0,0.25)',
        textAlign: 'center',
        maxWidth: '90%',
        minWidth: '300px',
      }}
    >
 <h2 className="text-lg font-semibold mb-4">Are you sure this session is deleted?</h2>
            <p className="mb-6">This action cannot be undone.</p>
            <div className="flex justify-center gap-4">
              <button
                onClick={handleDelete}
                style={{
      borderRadius: '9999px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      backgroundColor: '#a40a0aff', // red
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
    }}
              >
                Yes, Delete
              </button>
              <button
                onClick={() => setShowModal2(false)}
                style={{
      borderRadius: '9999px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      backgroundColor: '#298047ff', // red
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      marginBottom: '100px',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
    }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
{/* Delete Appointment */}

                <Link style={{paddingLeft: '50px'}}
      to={`/historygroomid?id=${item.pet}`}
    >
                <button
                 
                style={{
                  borderRadius: '9999px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      backgroundColor: '#c43b60ff', // pink
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
                }}
              >
                Detail of dog
              </button></Link> 
            </div>
          );
        })
      ) : (
        <div style={{ textAlign: 'center', color: '#888' }}>
          <p>No appointments for this day.</p>
          <Link to={`/add-appointment/`}>
            <button className="button">Add Appointment</button>
          </Link>
        </div>
      )}

      {showModal && (
       <div style={{
  position: 'fixed',
  top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.5)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000
}}>
  <div style={{
    backgroundColor: '#fff',
    padding: '24px',
    borderRadius: '12px',
    width: '340px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    fontFamily: 'sans-serif'
  }}>
    <h3 style={{ marginTop: 0, marginBottom: '16px', fontSize: '18px' }}>Update Appointment</h3>

    <div style={{ marginBottom: '16px' }}>
      <label style={{ fontWeight: 'bold', fontSize: '14px' }}>Staff</label>
      <input
      name='staff'
        value={staff}
        onChange={(e) => setStaff(e.target.value)}
        style={{
          width: '100%',
          padding: '8px',
          marginTop: '4px',
          borderRadius: '6px',
          border: '1px solid #ccc'
        }}
        placeholder="Search or select staff"
      />
      {filteredStaff.length > 0 && (
        <ul style={{
          listStyle: 'none',
          padding: '8px',
          margin: '8px 0 0 0',
          backgroundColor: '#f9f9f9',
          border: '1px solid #ddd',
          borderRadius: '6px',
          maxHeight: '120px',
          overflowY: 'auto'
        }}>
          {filteredStaff.map((s) => (
            <li
              key={s.id}
              onClick={() => {
                setStaff(s.name);
                handleAssignStaff(s);
                setFilteredStaff([]);
              }}
              style={{
                cursor: 'pointer',
                padding: '6px',
                borderBottom: '1px solid #eee',
                fontSize: '14px'
              }}
            >
              {s.name} — {getStatusLabel(s.status)}
            </li>
          ))}
        </ul>
      )}
    </div>

    <div style={{ marginBottom: '16px' }}>
      <label style={{ fontWeight: 'bold', fontSize: '14px' }}>
        <input
          type="checkbox"
          checked={done}
          onChange={(e) => setDone(e.target.checked)}
          style={{ marginRight: '8px' }}
        />
        Done
        
      </label>
    </div>

    <div style={{ textAlign: 'right' }}>
      <button
        onClick={handleUpdate}
        style={{
         borderRadius: '9999px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      backgroundColor: '#2bd779ff', // purple
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
     
        }}
      >
        Save
      </button>
      <button
        onClick={handleCloseModal}
        style={{
            borderRadius: '9999px',
      padding: '2px 8px',
      fontSize: '0.75rem',
      backgroundColor: '#c23c43ff', // purple
      color: '#fff',
      border: 'none',
      cursor: 'pointer',
      boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
     
        }}
      >
        Cancel
      </button>
    </div>
  </div>
</div>

      )}
      </div>
     

    </div>

    {showPopup && (
      <div className="popup">
        <div className="popup-inner">
          <Link to={`/add-appointment/`}><h2>Go Appointment Form</h2></Link>
          <button onClick={closePopup} className="button">Close</button>
        </div>
      </div>
    )}
  </div>
</div>


<AppointmentSummaryCards cards={summaryCards} />

<MonthlyCalendarBoard
  visibleMonth={visibleMonth}
  events={allTableEvents}
  onPreviousMonth={() => changeMonth(-1)}
  onNextMonth={() => changeMonth(1)}
  onToday={goToCurrentMonth}
  onEdit={handleOpenModal}
  onDelete={handleDelete}
/>



          </div>
          {/* Right Column */}
<div
  style={{
    width: '20%',
    backgroundColor: '#f9f9f9',
    padding: '1rem',
    position: 'relative', // do not use fixed
    overflowY: 'auto',
    flexShrink: 0,
    borderLeft: '1px solid #ddd',
    boxShadow: '0 0 5px rgba(0,0,0,0.1)'
  }}
    
>


  <h3 style={{ marginBottom: '1rem', borderBottom: '1px solid #ccc', paddingBottom: '0.5rem' }}>
    💬 Last Messages
  </h3>
  
  <ul className="chat-timeline" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
    {MessagePet.map((item, index) => (
      <li
        key={index}
        className="chat-message"
        style={{
          marginBottom: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: index % 2 === 0 ? 'flex-start' : 'flex-end',
        }}
      >
        <div
          className="chat-bubble subject"
          style={{
            backgroundColor: '#e0e0e0',
            color: '#333',
            padding: '8px 12px',
            borderRadius: '12px',
            maxWidth: '80%',
            marginBottom: '4px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            fontSize: '0.85rem',
          }}
        >
          <strong>{item.subject}</strong>
        </div>
        <div
          className="chat-bubble message"
          style={{
            backgroundColor: index % 2 === 0 ? '#fff' : '#dcf8c6',
            color: '#000',
            padding: '10px 14px',
            borderRadius: '12px',
            maxWidth: '80%',
            boxShadow: '0 1px 5px rgba(0,0,0,0.1)',
            fontSize: '0.95rem',
          }}
        >
          <p style={{ margin: 0 }}>{item.text}</p>
        </div>
      </li>
    ))}
  </ul>
</div>

        </main>
      </section>
   </>
  );
};

export default Index;
